import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { MultiSelect } from './inputs/MultiSelect';

export const RealEstatesFilter = ({
  setFiltersAndSort,
  filtersAndSort,
  realEstates
}) => {
  const onChange = selected => {
    setFiltersAndSort({
      ...filtersAndSort,
      realEstates: selected.map(s => s.value)
    });
  };

  const sortedRealEstates = [...realEstates].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const options = sortedRealEstates.map(realEstate => ({
    value: realEstate.id,
    label: realEstate.name
  }));

  options.sort((a, b) => a.label.localeCompare(b.label));

  const value = filtersAndSort.realEstates.map(realEstateId => ({
    value: realEstateId,
    label: realEstates.find(re => re.id === realEstateId)?.name
  }));

  return (
    <Form.Group>
      <Form.Label>Inmobiliarias</Form.Label>

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Inmobiliarias"
      />
    </Form.Group>
  );
};
RealEstatesFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  realEstates: PropTypes.array.isRequired
};
